import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid"
}
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_QBE = _resolveComponent("QBE")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        (_ctx.dataset.dsTypeCd == 'Qbe')
          ? (_openBlock(), _createBlock("form", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_Dropdown, {
                    id: "qbeDataSource",
                    class: ["kn-material-input", {
                'p-invalid': _ctx.v$.dataset.qbeDataSource.$invalid && _ctx.v$.dataset.qbeDataSource.$dirty,
              }],
                    options: _ctx.dataSources,
                    optionLabel: "label",
                    optionValue: "label",
                    modelValue: _ctx.v$.dataset.qbeDataSource.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.qbeDataSource.$model = $event)),
                    onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.qbeDataSource.$touch()))
                  }, null, 8, ["options", "modelValue", "class"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("managers.glossary.glossaryUsage.dataSource")) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.qbeDataSource,
                  additionalTranslateParams: {
              fieldName: _ctx.$t('managers.glossary.glossaryUsage.dataSource'),
            }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_Dropdown, {
                    id: "qbeDatamarts",
                    class: ["kn-material-input", {
                'p-invalid': _ctx.v$.dataset.qbeDatamarts.$invalid && _ctx.v$.dataset.qbeDatamarts.$dirty,
              }],
                    options: _ctx.businessModels,
                    optionLabel: "name",
                    optionValue: "name",
                    modelValue: _ctx.v$.dataset.qbeDatamarts.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.dataset.qbeDatamarts.$model = $event)),
                    onChange: _ctx.getDriversData,
                    onBeforeShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataset.qbeDatamarts.$touch()))
                  }, null, 8, ["options", "modelValue", "class", "onChange"]),
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("managers.datasetManagement.qbeDatamarts")) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.qbeDatamarts,
                  additionalTranslateParams: {
              fieldName: _ctx.$t('managers.datasetManagement.qbeDatamarts'),
            }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataset.dsTypeCd == 'Qbe' || _ctx.dataset.dsTypeCd == 'Federated')
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_Button, {
                label: _ctx.$t('managers.datasetManagement.viewQbeButton'),
                class: "p-col-2 p-mr-2 p-button kn-button--primary",
                style: {"max-height":"38px"},
                onClick: _ctx.openQbeQueryDialog
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_Button, {
                label: _ctx.$t('managers.datasetManagement.openQbeButton'),
                class: "p-col-2 p-button kn-button--primary",
                disabled: _ctx.parentValid,
                onClick: _ctx.openDatasetInQBE
              }, null, 8, ["label", "disabled", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      class: "dmdialog",
      visible: _ctx.qbeQueryDialogVisible,
      modal: true,
      closable: false,
      style: _ctx.qbeDescriptor.style.codeMirror
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
          start: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t("managers.datasetManagement.viewQbeButton")), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.qbeQueryDialogVisible = false))
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VCodeMirror, {
          class: "kn-height-full",
          ref: "codeMirror",
          value: _ctx.qbeQuery,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.qbeQuery = $event)),
          options: _ctx.codemirrorOptions
        }, null, 8, ["value", "options"])
      ]),
      _: 1
    }, 8, ["visible", "style"]),
    (_ctx.qbeVisible)
      ? (_openBlock(), _createBlock(_component_QBE, {
          key: 0,
          visible: _ctx.qbeVisible,
          dataset: _ctx.qbeDataset,
          "from-ds-management": true,
          returnQueryMode: true,
          getQueryFromDatasetProp: _ctx.getQueryFromDataset,
          onQuerySaved: _ctx.onQbeDialogSave,
          onClose: _ctx.onQbeDialogClose
        }, null, 8, ["visible", "dataset", "getQueryFromDatasetProp", "onQuerySaved", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}